import React from 'react';

import BobModal from '../../../components/BobModal';

import * as classes from './ExecutiveSummaryTileModal.module.css';

const ExecutiveSummaryTileModal = ({
    setTileModalOpen,
    setSelectedTitle,
    title,
    children,
    ...props
}) => {

    const handleClose = () => {
        setSelectedTitle('');
        setTileModalOpen(false);
    };

    return (
        <BobModal
            title={title}
            hidebuttons={true}
            isRemoveFooter={true}
            showToolTips={true}
            modalMaxWidth={15000}
            modalBodyStyle={title === 'Faults By Site' ? classes.Map : null}
            headerOverride={classes.HeaderOverride}
            bodyOverride={classes.ModalClass}
            onClose={() => handleClose()}
        >
            {children}
        </BobModal>
    );
};

export default ExecutiveSummaryTileModal;
